import { createStore } from 'vuex'

// Create a new store instance.
const store = createStore({
  state () {
    return {
      config: {},
      // tpListarSub: {},
      // tpExisteSub: {}
    }
  },
  mutations: {
    setConfig (state, value) {
      state.config = value;
    },
    // setTpListarSub (state, value) {
    //   state.tpListarSub = value;
    // },
    // setTpExisteSub (state, value) {
    //   state.tpExisteSub = value;
    // }
  }
});

export default store;